import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { CaretDown } from "@phosphor-icons/react";
import React from "react";
import { TextFieldBOValidate } from "../../../TextFieldBO/TextFieldBOValidate";

export const DataCoberturaMedica = ({ register, errors, watch }) => {
  const { obraSocial, obraSocialTelefono, obraSocialCredencial } =
    watch() || {};
  return (
    <Box>
      <Accordion>
        <AccordionSummary
          expandIcon={<CaretDown size={32} />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography fontWeight={700} color={"primary"}>
            Cobertura médica
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TextFieldBOValidate
            register={register}
            name="obraSocial"
            label={"Nombre de la cobertura médica"}
            errors={errors}
            maxLength={50}
            length={obraSocial?.length}
          />
          <TextFieldBOValidate
            register={register}
            name="obraSocialTelefono"
            label={"Teléfono "}
            errors={errors}
            maxLength={100}
            length={obraSocialTelefono?.length}
          />
          <TextFieldBOValidate
            register={register}
            name="obraSocialCredencial"
            label={"Número de credencial"}
            errors={errors}
            maxLength={100}
            length={obraSocialCredencial?.length}
          />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
